export default __webpack_public_path__ + "static/media/add_url_demo.6d71e1a5.png";